module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0"
  }, [_c('span', {
    staticClass: "inline-block h-auto m-t-5"
  }, [(!_vm.image && (_vm.type == 1 || _vm.type == 2)) ? _c('div', {
    staticClass: "text-black",
    domProps: {
      "textContent": _vm._s('沒有圖片')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.image) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.image,
      "id": 'img-load' + _vm.index + '-' + _vm.type,
      "data-toggle": "modal",
      "data-target": '#myModal-' + _vm.index + '-' + _vm.type
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('label', {
    staticClass: "btn-upload btn btn-default",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "for": 'file-upload-' + _vm.index + '-' + _vm.type
    }
  }, [_vm._v("\n      選擇圖片\n    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": 'file-upload-' + _vm.index + '-' + _vm.type,
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'myModal-' + _vm.index + '-' + _vm.type,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("廣告")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("返回")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b94e10c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Platform/Temp/ImgUploadTemp.vue
// module id = 2540
// module chunks = 1